import type { LikeActionResult } from '~/types/blog'
import { useLikePersistence, type LikePersistenceType } from './useLikePersistence'

type LikeTarget = {
  ID?: number
  likeCount?: number
}

export const useOptimisticLike = (
  type: LikePersistenceType,
  requestLike: (id: number) => Promise<LikeActionResult>
) => {
  const persistence = useLikePersistence(type)

  const isLiked = (target: LikeTarget | null | undefined) => persistence.isLiked(target?.ID)

  const like = (target: LikeTarget | null | undefined, onLiked: () => void) => {
    const id = Number(target?.ID || 0)
    if (!target || id <= 0 || persistence.isLiked(id)) {
      return
    }

    const request = requestLike(id)
    target.likeCount = Number(target.likeCount || 0) + 1
    persistence.markLiked(id)
    onLiked()

    void request.then(data => {
      if (Number(target.ID) === id) {
        target.likeCount = Number(data.likeCount || 0)
      }
    }).catch(() => undefined)
  }

  return {
    isLiked,
    like
  }
}
